import { httpClient } from "./httpClient";

const base = "/api/horarios";

export const listarHorariosPorCurso = (cursoId) => httpClient.get(`${base}/curso/${cursoId}`);
export const obtenerHorario = (id) => httpClient.get(`${base}/${id}`);
export const crearHorario = (payload) => httpClient.post(base, payload);
export const actualizarHorario = (id, payload) => httpClient.put(`${base}/${id}`, payload);
export const eliminarHorario = (id) => httpClient.del(`${base}/${id}`);

const horariosService = {
  listarPorCurso: listarHorariosPorCurso,
  obtener: obtenerHorario,
  crear: crearHorario,
  actualizar: actualizarHorario,
  eliminar: eliminarHorario,
};

export default horariosService;
